import { render } from "./header.vue?vue&type=template&id=605d4b93&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=605d4b93&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605d4b93"],['__file',"src/components/public/header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "605d4b93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('605d4b93', __exports__)) {
    console.log('reload')
    api.reload('605d4b93', __exports__)
  }
  
  module.hot.accept("./header.vue?vue&type=template&id=605d4b93&scoped=true", () => {
    console.log('re-render')
    api.rerender('605d4b93', render)
  })

}


export default __exports__